import './Button.css'

export default function Button(props: {text: string}) {
    return (
        <button className="button">{props.text}</button>
    )
}